import { apiFetch } from '@/platform/lib/api';

const MAX_BYTES = 10 * 1024 * 1024;

const BLOG_ACCEPT =
  'image/*,.pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document';

export { BLOG_ACCEPT, MAX_BYTES as BLOG_UPLOAD_MAX_BYTES };

export function publicUrlForObjectPath(objectPath: string): string {
  const bucket = process.env.NEXT_PUBLIC_GCS_ATTACHMENTS_BUCKET || 'attachments';
  return `https://storage.googleapis.com/${bucket}/${objectPath}`;
}

export async function uploadBlogAsset(file: File, postId?: string): Promise<string> {
  if (file.size > MAX_BYTES) {
    throw new Error('File must be 10 MB or smaller.');
  }
  const signed = await apiFetch<{
    uploadUrl: string;
    objectPath: string;
    publicUrl?: string;
  }>('/uploads/signed-url', {
    method: 'POST',
    body: JSON.stringify({
      purpose: 'blog',
      postId: postId?.trim() || '',
      filename: file.name,
      contentType: file.type || 'application/octet-stream',
    }),
  });

  if (!signed.uploadUrl.includes('signed=stub')) {
    const put = await fetch(signed.uploadUrl, {
      method: 'PUT',
      body: file,
      headers: { 'Content-Type': file.type || 'application/octet-stream' },
    });
    if (!put.ok) {
      throw new Error('Upload failed');
    }
  }

  return signed.publicUrl || publicUrlForObjectPath(signed.objectPath);
}

export function isImageFile(file: File): boolean {
  return file.type.startsWith('image/');
}
